<template>
  <BModal
    :visible="internalIsShowModal"
    title="今の転職意欲を教えてください"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    hide-footer
    centered
  >
    <div
      class="button-container"
      v-for="jobOption in jobOptions"
      :key="jobOption.id"
    >
      <AppButton @click="onClick(jobOption.id)" class="button">{{
        jobOption.level
      }}</AppButton>
    </div>
    <div class="question-note">
      選択した転職意欲に応じて、応募実績のある事業所から採用やお仕事に関するスカウトメッセージが届くことがあります
    </div>
  </BModal>
</template>

<script lang="ts">
import { accountService } from "@/app/services/AccountService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";
import { Component, Vue } from "vue-facing-decorator";
import { BModal } from "bootstrap-vue";

@Component({
  components: {
    AppButton,
    BModal
  }
})
export default class JobChangeModal extends Vue {
  isAlreadyAsked = false;
  jobOptions: jobChangeOption[] = [];

  get internalIsShowModal(): boolean {
    return !this.isAlreadyAsked && this.jobOptions.length > 0;
  }

  async created() {
    try {
      this.jobOptions = await accountService.fetchJobChangeList();
    } catch (error) {
      console.log(error);
      showErrorModal(this, error as ErrorType);
    }
  }

  async onClick(jobChangeID: number) {
    this.$loading.show(99999);
    try {
      await accountService.registerUserInformation({
        jobChange: jobChangeID
      });
      // 次回画面ロード時にユーザ情報が更新されるまでの間、
      // モーダルが表示されてしまうため、モーダルを閉じる前にユーザ情報を更新する
      await accountService.updateUserData();
    } catch (error) {
      showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
      this.isAlreadyAsked = true;
    }
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
type jobChangeOption = {
  id: number;
  level: string;
};
</script>

<style lang="scss" scoped>
.button-container {
  display: flex;
  flex-direction: column;
}

.button {
  margin-bottom: 1em;
}

.question-note {
  margin: 0 0 1em;
  font-size: medium;
}
</style>
